import React, {useEffect} from 'react';

export default function Info(props){

    useEffect(()=>{
        props.handleMenu(
            {
                title: 'ARAL werkbon',
                showBackButton: true,
            })
    },[])

    return(
        <div className="padding">
        <br/><br/>
WerkbonApp is de digitale oplossing voor de papieren werkbon, Voor de ondernemer die in control wil blijven en efficiënter de gewerkte uren in beeld houdt. Op de werkbonApp registreer je je uren, project, materiaal en gereden kilometers. Je kunt foto’s toevoegen van bijv. de inkooporder en je klant zet bij akkoord een digitale handtekening. Dit kan direct op de smartphone of tablet. Wij zorgen er dan voor dat de bon als PDF in de klantmail terecht komt. Efficient, snel en simpel.
<br/><br/>
De werkbonApp  <br/>
Het invullen van de werkbon is heel simpel. Selecteer het project. Vervolgens ga door het scherm en vul je de werkbon in (Uren, materialen etc.). Er verschijnen dan steeds nieuwe invulvelden.
Heb je alle uren van de betreffende week ingevuld, klik dan op Verzenden en de werkbon wordt verstuurd naar je klant met de werkbon als PDF toegevoegd. Ook de administratie krijgt de werkbon ter controle.
<br/><br/>
Heb je nog meer hulp nodig of heb je vragen? 
(<a href="mailto:crediteuren@arallasservice.nl">crediteuren@arallasservice.nl</a> en ☎ (<a href="tel:0651473832">0651473832</a>) bereiken. Samen de projecten digitaliseren en dat gaat ons tijd besparen.
<br/><br/>
Heel veel werkbon-plezier!
<br/><br/>
De app is verkrijgbaar voor Android en IOS smartphone/tablets.
<br/><br/>
<a href="https://aral.vedebo.net/handleiding.docx" target="_blank" rel="noopener noreferrer">[Download hier de handleiding]</a>
        
        <br/><br/>
        <a href="https://aral.vedebo.net/info_brief_metaalunie.pdf" target="_blank" rel="noopener noreferrer">[Info brief metaalunie]</a>     
        </div>
    )
}